const STATUTS = {
  valide: { label: "Valide", classes: "bg-emerald-950 text-emerald-400 border-emerald-700" },
  a_recycler: { label: "À recycler", classes: "bg-amber-950 text-amber-400 border-amber-700" },
  depasse: { label: "Dépassé", classes: "bg-red-950 text-red-400 border-red-700" },
  non_forme: { label: "Non formé", classes: "bg-gray-800 text-gray-300 border-gray-600" },
};

export function statutLabel(statut) {
  return STATUTS[statut]?.label || statut;
}

function formatDuree(jours) {
  const abs = Math.abs(jours);
  const ans = Math.floor(abs / 365);
  const mois = Math.round((abs % 365) / 30.44);
  if (ans > 0) {
    const m = mois === 12 ? 0 : mois;
    return m > 0 ? `${ans} an${ans > 1 ? "s" : ""} et ${m} mois` : `${ans} an${ans > 1 ? "s" : ""}`;
  }
  if (mois > 0) return `${mois} mois`;
  return `${abs} jour${abs > 1 ? "s" : ""}`;
}

export default function StatutBadge({ statut, joursRestants, showDays = true }) {
  const s = STATUTS[statut] || STATUTS.non_forme;
  return (
    <span className="inline-flex items-center gap-2" data-testid={`statut-badge-${statut}`}>
      <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${s.classes}`}>
        {s.label}
      </span>
      {showDays && joursRestants !== null && joursRestants !== undefined && (
        <span className={`text-xs font-mono ${joursRestants < 0 ? "text-red-400" : joursRestants <= 60 ? "text-amber-400" : "text-muted-foreground"}`}>
          {joursRestants < 0 ? `expiré depuis ${formatDuree(joursRestants)}` : formatDuree(joursRestants)}
        </span>
      )}
    </span>
  );
}
